module.exports = __webpack_public_path__ + "static/media/27.8484470a.jpg";